<!--
 * @Author: your name
 * @Date: 2020-03-13 16:31:00
 * @LastEditTime: 2024-06-07 08:38:42
 * @LastEditors: yjf531 yjf531@126.com
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Apply.vue
 -->
<template>
  <div
    class="Baoming21"
    :style="
      `background: url('${require('../assets/baoming2/bg.jpg')}'); background-size: 100% 100%;`
    "
  >
    <img class="sub-logo2" src="../assets/baoming2/logo.png" />
    <div class="content">
      <div class="body">
        <div class="top">
          <img src="../assets/baoming2/title.png" class="topImg" />
        </div>
        <div class="registered21">
          <div>
            <van-field
              v-model="name"
              label="姓名"
              :left-icon="require('../assets/baoming2/icon.png')"
              class="input-class"
            >
              <template v-slot:input>
                <input
                  type="text"
                  class="van-field__control custom_input_style"
                  v-model="name"
                />
              </template>
            </van-field>
            <van-field
              v-model="unit_name"
              label="单位"
              :left-icon="require('../assets/baoming2/icon.png')"
              class="input-class"
            >
              <template v-slot:input>
                <input
                  type="text"
                  class="van-field__control custom_input_style"
                  v-model="unit_name"
                />
              </template>
            </van-field>
            <van-field
              v-model="tel"
              label="电话"
              :left-icon="require('../assets/baoming2/icon.png')"
              class="input-class"
            >
              <template v-slot:input>
                <input
                  type="text"
                  class="van-field__control custom_input_style"
                  v-model="tel"
                />
              </template>
            </van-field>
            <van-field
              v-model="province"
              label="是否住宿"
              :left-icon="require('../assets/baoming2/icon.png')"
              :right-icon="require('../assets/baoming2/icon2.png')"
              class="input-class"
              @click="
                () => {
                  this.showPicker2 = true;
                }
              "
            >
              <template v-slot:input>
                <input
                  type="text"
                  class="van-field__control custom_input_style"
                  v-model="province"
                  readonly
                />
              </template>
            </van-field>

            <van-field
              v-model="mechanism"
              label="住宿类型"
              :left-icon="require('../assets/baoming2/icon.png')"
              :right-icon="require('../assets/baoming2/icon2.png')"
              class="input-class"
              @click="
                () => {
                  this.showPicker3 = true;
                }
              "
            >
              <template v-slot:input>
                <input
                  type="text"
                  class="van-field__control custom_input_style"
                  v-model="mechanism"
                  readonly
                />
              </template>
            </van-field>

            <van-field
              label="住宿日期"
              :left-icon="require('../assets/baoming2/icon.png')"
              class="input-class"
            >
              <!-- <template v-slot:input>
                <input
                  type="text"
                  class="van-field__control custom_input_style"
                  v-model="unit_nature"
                />
                <van-checkbox-group 
                  value="{{ unit_nature }}" 
                  bind:change="onChangeDay">
                  <van-checkbox name="6.23">6.23</van-checkbox>
                  <van-checkbox name="6.24">6.24</van-checkbox>
                  <van-checkbox name="6.25">6.25</van-checkbox>
                </van-checkbox-group>
              </template> -->
              <template #input>
                <van-checkbox-group v-model="unit_nature" direction="horizontal" style="width: 256px;">
                  <van-checkbox name="6.23" shape="square">6.23</van-checkbox>
                  <van-checkbox name="6.24" shape="square">6.24</van-checkbox>
                  <van-checkbox name="6.25" shape="square">6.25</van-checkbox>
                </van-checkbox-group>
              </template>
            </van-field>

            <!-- <van-field
              v-model="unit_nature"
              label="科室"
              :left-icon="require('../assets/baoming2/icon.png')"
              class="input-class"
            >
              <template v-slot:input>
                <input
                  type="text"
                  class="van-field__control custom_input_style"
                  v-model="unit_nature"
                />
              </template>
            </van-field> -->
            <!-- <van-field
              v-model="unit_nature"
              label="单位性质"
              :left-icon="require('../assets/baoming2/icon.png')"
              :right-icon="require('../assets/baoming2/icon2.png')"
              class="input-class"
              @click="
                () => {
                  this.showPicker5 = true;
                }
              "
            >
             <template v-slot:label>
               <div class="van-cell__title van-field__label" style="width: 68px;"><span>单位性质</span></div>
            </template>
              <template v-slot:input>
                <input
                  type="text"
                  class="van-field__control custom_input_style"
                  style="margin-left: 24px"
                  v-model="unit_nature"
                  readonly
                />
              </template>
            </van-field> -->


            <!-- <van-field
              v-model="job"
              label="职务"
              :left-icon="require('../assets/baoming2/icon.png')"
              :right-icon="require('../assets/baoming2/icon2.png')"
              class="input-class"
              @click="
                () => {
                  this.showPicker4 = true;
                }
              "
            >
              <template v-slot:input>
                <input
                  type="text"
                  class="van-field__control custom_input_style"
                  v-model="job"
                  readonly
                />
              </template>
            </van-field> -->

            <!-- <van-field
              v-model="job"
              label="参会形式"
              autosize
              :left-icon="require('../assets/baoming2/icon.png')"
              :right-icon="require('../assets/baoming2/icon2.png')"
              class="input-class"
              @click="
                () => {
                  this.showPicker4 = true;
                }
              "
            >
              <template v-slot:input>
                <input
                  type="text"
                  class="van-field__control custom_input_style"
                  v-model="job"
                  readonly
                />
              </template>
            </van-field> -->

            <!-- <p class="tip2">
              请务必填写真实信息，以便顺利参加会议。
            </p> -->
             <p class="tip2">
              您提供的所有信息仅限该会议报名使用且受到严格保护
            </p>

            <van-row class="bottom" type="flex" justify="center">
              <van-col>
                <!-- <van-button type="info" class="confirm" @click="editUser()">确认提交</van-button> -->
                <img src="../assets/baoming2/submit.png" class="confirm" @click="editUser()"/>
              </van-col>
            </van-row>
          </div>
        </div>
        <div class="bottom2">
          <img src="../assets/baoming2/bottom.png" class="bottomImg" />
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker2" position="bottom">
      <van-picker
        show-toolbar
        :columns="[
          '是',
          '否',
          // '河北',
          // '山西',
          // '内蒙古',
          // '辽宁',
          // '吉林',
          // '黑龙江',
          // '上海',
          // '江苏',
          // '浙江',
          // '安徽',
          // '福建',
          // '江西',
          // '山东',
          // '河南',
          // '湖北',
          // '湖南',
          // '广东',
          // '广西',
          // '海南',
          // '重庆',
          // '四川',
          // '贵州',
          // '云南',
          // '西藏',
          // '陕西',
          // '甘肃',
          // '青海',
          // '宁夏',
          // '新疆',
          // '兵团',
          // '香港',
          // '澳门',
          // '台湾',
        ]"
        @cancel="showPicker2 = false"
        @confirm="onConfirm2"
      />
    </van-popup>
    <van-popup v-model="showPicker3" position="bottom">
      <van-picker
        show-toolbar
        :columns="['单间', '双间']"
        @cancel="showPicker3 = false"
        @confirm="onConfirm3"
      />
    </van-popup>
    <!-- <van-popup v-model="showPicker4" position="bottom">
      <van-picker
        show-toolbar
        :columns="[
          '院长/副院长/书记',
          '非临床科室管理者',
          '临床科室管理者',
          '药剂科',
          '其他',
        ]"
        @cancel="showPicker4 = false"
        @confirm="onConfirm4"
      />
    </van-popup> -->
    <van-popup v-model="showPicker4" position="bottom">
      <van-picker
        show-toolbar
        :columns="[
          '线上网络培训'
        ]"
        @cancel="showPicker4 = false"
        @confirm="onConfirm4"
      />
    </van-popup>
    <van-popup v-model="showPicker5" position="bottom">
      <van-picker
        show-toolbar
        :columns="[
          '医疗卫生行政机构',
          '三级公立医院',
          '二级公立医院',
          '其他',
        ]"
        @cancel="showPicker5 = false"
        @confirm="onConfirm5"
      />
    </van-popup>
     <share></share>
  </div>
</template>

<script>
import { Http } from "@/utils/http.js";
import api from "@/config/api.js";
import Cookies from "js-cookie";
import axios from "axios";
// import VConsole from 'vconsole'

export default {
  name: "Apply",
  data() {
    return {
      isSubmit: false,
      name: "",
      wx_name: "",
      wx_province: "",
      wx_city: "",
      wx_sex: "",
      mechanism: "", //职称
      job: "", // 职务
      unit_name: "",
      unit_nature: [], // 单位性质
      tel: "",
      openid: "",
      province: "",
      meeting_id: 19, // 会议ID
      showPicker2: false,

      showPicker3: false, // 职称
      showPicker4: false, // 职务
      showPicker5: false, // 单位性质
      meetSetData: [] // 会议设置
    };
  },

  methods: {
    // 省份下拉框
    onConfirm2(value) {
      this.showPicker2 = false;
      this.province = value;
    },

    // 职称下拉框
    onConfirm3(value) {
      this.showPicker3 = false;
      this.mechanism = value;
    },

    // 职务下拉框
    onConfirm4(value) {
      this.showPicker4 = false;
      this.job = value;
    },

    // 单位性质
    onConfirm5(value) {
      this.showPicker5 = false;
      this.unit_nature = value;
    },

    // 弹框
    customAlert(msg) {
      this.$dialog.alert({
        message: msg,
      });
      return;
    },
    // 验证码判断
    check() {
      this.yanZhengMa = this.yanZhengMa.trim();
      if (!this.yanZhengMa) {
        this.customAlert("验证码不能为空");
        return false;
      }
      if (this.yanZhengMa != "zjjc202004") {
        this.customAlert("验证码不对");
        return false;
      }
      this.isShow = true;
      this.bottom = "bottom3";
      return;
    },
    // 修改用户信息
    editUser() {
      this.name = this.name.trim();
      this.tel = this.tel.trim();
      this.province = this.province.trim();
      this.mechanism = this.mechanism.trim();
      this.job = this.job.trim();
      this.unit_name = this.unit_name.trim();
     // this.unit_nature = this.unit_nature;

      // 根据城市判断二维码
      var province = this.province
      var dataSeting = this.meetSetData.filter(val => {
        if(province == val.title){
          return true
        }
      })
      if (this.province == '是' && this.unit_nature.length == 0) {
        this.customAlert("请选择住宿日期");
        return false;
      }

      if (
        !this.name ||
        !this.tel ||
        !this.province ||
        !this.unit_name
      ) {
        this.customAlert("个人信息请填写完整");
        return false;
      }
      // 判断手机号格式
      const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.tel)) {
        this.customAlert("请输入准确的手机号");
        return false;
      }
      // if(this.isSubmit){
      //     this.customAlert('正在提交')
      //     return false
      // }
      this.isSubmit = true;
      let data = {};
      data.openid = this.openid;
      data.tel = this.tel;
      data.name = this.name;
      data.wx_name = this.wx_name;
      data.wx_sex = this.wx_sex;
      data.province = this.province;
      data.wx_province = this.wx_province;
      data.wx_city = this.wx_city;
      data.mechanism = this.mechanism;
      data.job = this.job;
      data.unit_name = this.unit_name;
      data.unit_nature = this.unit_nature.join(',');
     // data.unit_nature = this.unit_nature;
      data.meeting_id = this.meeting_id;
      // console.log('提交会议----111')
      // console.log(data)
      // console.log('提交会议----111')

      // return
      Http.post(api.addMeetingUser2, data).then((response) => {
        // this.isSubmit = false;
        // this.$router.push({ name: "BaomingSuccess2" });
        // return false;
        this.isSubmit = false;
        if(response.code == 1){
            // 提交成功
            // this.customAlert('提交成功')
            // this.$router.push({ name: "BaomingSuccess"})
            var province = this.province
            var dataSeting = this.meetSetData.filter(val => {
              if(province == val.title){
                return true
              }
            })
            var timestamp = Date.parse(new Date());
            if(dataSeting.length > 0){
              this.$router.push({ name: "BaomingSuccess2", query: { id: dataSeting[0].id,v: timestamp }  });
            }else{
              this.customAlert('注册成功')
            }
            return false
        }else{
            // 发送失败
            this.customAlert(response.msg)
           // this.$router.push({ name: "BaomingSuccess2" });
            return false
        }
      });
      return false;
    },

    // 获取会议设置
    getMeetingSetList() {
      let data = {};
      data.pageSize = 100
      data.pageNum = 1
      data.list_id = this.meeting_id
      Http.post(api.getMeetingSetList, data).then((res) => {
        //const data = res.data
       // console.log(data)
        if (res.code == 1) {
          this.meetSetData = res.data
        }
      });
      return false;
    },

    // 获取用户信息
    getUserInfo() {
      this.wx_name = Cookies.get("nickname");
      this.wx_province = Cookies.get("province");
      this.wx_city = Cookies.get("city");
      this.wx_sex = Cookies.get("sex");
      return;
    },
    // 获取会议开关
    getSwitch() {
        let data = {}
        data.meetid = this.meeting_id
        data.type = 3
        Http.post(api.getQrcode, data).then((response) => {
            const a = response.data.thumb
            if(a == 2){
              this.$router.push({ name: "BaomingClose2", query: { v: 22, id: this.meeting_id } })
            }
        });
        return false;
    }
  },
  created: function() {
    this.getSwitch()
  },
  mounted: function() {
    document.title = '会议报名'
    this.openid = Cookies.get("openid");
    // 引入调试工具
	//	new VConsole()
    // 跳转到首页
    // if (!this.openid) {
    //   this.$router.push({ name: "Baoming2" });
    // }
    // 获取用户信息
    this.getUserInfo();
    // 获取会议设置
    this.getMeetingSetList();
  },
};
</script>

<style lang="less">
.Baoming21 {
  font-size: 16px;
  display: flex;
  flex-direction: column;
  //  background-color: #041d34;
  min-height: 100vh;
  .sub-logo2 {
    position: absolute;
    width: 40px;
    top: 20px;
    left: 20px;
  }
  .content {
    position: relative;
    min-height: 100vh;
    .top {
      margin: 80px auto 0;
      width: 90%;
      .topImg {
        width: 100%;
      }
    }
    .bottom2 {
      margin-top: 12px;
      position: fixed;
      bottom: -8px;
      .bottomImg {
        width: 100%;
      }
      pointer-events: none;
    }
    .bottom3 {
      margin-top: 12px;
      .bottomImg {
        width: 100%;
      }
    }
    .registered21 {
      border-radius: 4px;
      box-sizing: border-box;
      padding: 0 20px;
      width: 94%;
      margin: auto;
      position: relative;
      z-index: 2;
      .title {
        margin-top: 20px;
        margin-bottom: 28px;
        font-size: 20px;
        text-align: center;
        height: 20px;
        line-height: 20px;
        color: #0c0c0c;
      }
      .van-cell {
        align-items: center;
        //   border-bottom: 1px solid #dcdcdc;
        font-size: 14px;
        margin-top: 10px;
      }
      .van-field__control {
        //    color: #fff;
      }
      ::-webkit-input-placeholder {
        color: #072d47;
      }
      .van-cell__value {
        margin-left: 12px;
      }
      .van-cell {
        margin-top: 0px;
        background-color: transparent;
      }
      .van-field__label {
        //width: 30px;
        width:fit-content;
        font-size: 16px;
        color: #0c0c0c;
      }

      .van-cell:not(:last-child)::after {
        border-bottom: 0px;
      }
      .tip2 {
        font-size: 12px;
        font-weight: 500;
        color: #0c0c0c;
        text-align: center;
      }
      .bottom {
        margin-bottom: 30px;
        .confirm {
          width: 160px;
          margin-top: 20px;
          //   height: 40px;
          //   border-radius: 18px;
          //   font-size: 18px;
          //   background-color:#041f39;
          //     border: 1px solid #74a2ce;
          //     color: #2d6d9c;
        }
      }
    }
    .custom_input_style {
      // color: #fff;
      border-bottom: 1px solid #0c0c0c;
    }
    
    .input-class {
      opacity: 0.8;
      border-bottom: 0;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Baoming21.vue